import React, { useMemo } from "react";
import { View, StyleSheet } from "react-native";
import NtText from "./NtText";
import NtDevider from "./NtDevider";
import NtListActionButton from "./NtListActionButton";
import { useTheme } from "../context/ThemeContext";

function NtListRow({
  item,
  columns,
  renderCustom,
  onActionLoading = false,
  onActionIcon,
  onActionColor,
  onActionPress,
  // Slot rendered to the LEFT of the primary action button. Useful for a
  // secondary action like a download button before a destructive delete.
  renderLeadingAction,
  // Slot rendered AFTER the primary action button.
  renderAction,
  rowContainerStyle,
}) {
  const { theme } = useTheme();
  const styles = useMemo(() => makeStyles(theme), [theme]);

  const renderCell = (column) => {
    const render = renderCustom ? renderCustom(item, column?.id) : null;
    return (
      <View style={[styles.cell, rowContainerStyle]} key={column.id}>
        {typeof render === "string" || typeof render === "number" ? (
          <NtText style={styles.text}>{render}</NtText>
        ) : render !== undefined && render !== null ? (
          render
        ) : (
          <NtText style={styles.text}>{item[column.id]}</NtText>
        )}
      </View>
    );
  };

  return (
    <View style={styles.container}>
      <View style={styles.row}>
        {columns?.map((each) => renderCell(each))}
        {renderLeadingAction ? (
          <View style={styles.actionGap}>{renderLeadingAction}</View>
        ) : null}
        {onActionPress ? (
          <NtListActionButton
            color={onActionColor}
            icon={onActionIcon}
            loading={onActionLoading}
            onPress={onActionPress}
          />
        ) : null}
        {renderAction}
      </View>
      <NtDevider />
    </View>
  );
}

const makeStyles = (t) =>
  StyleSheet.create({
    container: {},
    row: {
      flexDirection: "row",
      alignItems: "center",
      paddingVertical: 10,
    },
    cell: { flex: 1, alignItems: "flex-start", justifyContent: "center" },
    actionGap: { marginRight: 6 },
    text: {
      fontSize: 12,
      fontWeight: "500",
      color: t.text,
    },
  });

export default NtListRow;
